/// <reference path="../../../../../shared/utils/View.ts"/>
/// <reference path="../../app.d.ts"/>
/// <reference path="../../../../../shared/models/generated/MitgliedschaftEmpfehlungsdatenResponseApi.d.ts"/>

import { BasicUserService } from '../../../../../shared/services/BasicUserService';
import { AppPersistenceService } from '../services/AppPersistenceService';
import { User } from '../../../../../shared/models/api/User/User';
import { AppApplicationService } from '../services/AppApplicationService';
import { AppApiService } from '../services/AppApiService';
import { defaults } from '../defaults';

import { InputPageController } from './steps/InputPageController';
import { CheckPageController } from './steps/CheckPageController';
import { ApplicationPages } from '../Constants';
import { AppUtils } from '../../../../../shared/utils/index';

export class App implements AppController {
	private readonly loader: BasicLoader<MglModularSystemV2AppDefinition>;
	private readonly options: MglModularSystemV2AppOptions;
	private readonly appPersistenceService: AppPersistenceService;
	private readonly appApplicationService: AppApplicationService;
	private readonly appApiService: AppApiService;
	private readonly userService: BasicUserService<MglModularSystemV2AppDefinition>;

	//currently necessary MglValidationService is use this
	private stepController: StepController;

	 
	constructor(element: HTMLElement, options: MglModularSystemV2AppOptions, loader: BasicLoader<MglModularSystemV2AppDefinition>) {
		this.loader = loader;
		this.options = $.extend(true, {}, defaults, options);

		// services
		this.appPersistenceService = new AppPersistenceService(this.options);
		this.appApplicationService = new AppApplicationService(this.options);
		this.userService = new BasicUserService(this.options);
		this.appApiService = new AppApiService(options);
	}

	public start(): void {
		this.callDependencyLoader();
	}

	public callDependencyLoader(): void {
		this.loader._loadDependencies(this.initApplication.bind(this));
	}

	public initApplication(): void {
		AppUtils.View.startLoader();
		this.updateIbanJson();
		this.appPersistenceService.prepareApplicationSession();
		this.userService.getUser((user: User) => {
			this.checkForFriendshipRecommendation();
			this.restoreStep(user);
		});
	}

	private updateIbanJson(): void {
		this.options.subapps.forEach((subapp: Record<string, any>) => {
			if (subapp.name === "IBANApplication") {
				subapp.app.hideIbanLightbox = true;
			}
		});
	}

	private checkForFriendshipRecommendation(): void {
		const recommendationParam = T.Utils.Helper.getUrlParameter('recommendation');
		if (!AppUtils.Helper.isEmptyString(recommendationParam)) {
			this.appApiService.resolveFriendshipRecommendation(recommendationParam, this.handleResolveRecommendationParamSuccess.bind(this), this.handleResolveRecommendationParamError.bind(this));
		}
	}

	private handleResolveRecommendationParamSuccess(data: ApiResponse<EmpfehlungsdatenResponseApi>): void {
		if (data.Success && data.Data) {
			this.appPersistenceService.setRecommendationData(data.Data);
		}
		T.Utils.View.stopLoader();
	}

	private handleResolveRecommendationParamError(): void {
		T.Utils.View.stopLoader();
	}

	private restoreStep(user: User): void {
		const applicationModel = this.appPersistenceService.getApplicationModel();

		if (applicationModel.Step === 1) {
			const checkOptions = this.appApplicationService.preparePageOptions(ApplicationPages.Check);
			const checkController = new CheckPageController(this, checkOptions, user, this.loader);
			checkController.start();
		} else {
			this.stepController = new InputPageController(this, this.options, this.loader, user);
			this.stepController.start();
		}
	}

	public afterRenderApp(): void {
		const mglApplication = this.appPersistenceService.getApplicationModel();

		this.loader.initAdditionalModules(this.options.$ctx);
		AppUtils.View.stopLoader();

		this.appPersistenceService.setApplicationModel(mglApplication);
		this.loader.complete();
	}
}
